var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicroonde(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 65.98 65.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke:#e6007e;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2px;}.cls-2{fill:#e6007e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "micro_ondes",
    "data-name": "micro ondes"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.8,14.61A29.8,29.8,0,0,0,1,33,32,32,0,0,0,55.61,55.61a32,32,0,0,0,0-45.24h0A31.79,31.79,0,0,0,33,1a29.47,29.47,0,0,0-17.9,5.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.53,11.62a1.57,1.57,0,1,0-1.11-.46A1.57,1.57,0,0,0,10.53,11.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.94,44.7H13.48a.77.77,0,0,0-.78.78v2.34a1.56,1.56,0,0,0,1.56,1.56h3.9a1.56,1.56,0,0,0,1.56-1.56V45.48A.77.77,0,0,0,18.94,44.7Zm-4.68,3.12V46.26h3.9v1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M52.5,44.7H47a.77.77,0,0,0-.78.78v2.34a1.56,1.56,0,0,0,1.56,1.56h3.9a1.56,1.56,0,0,0,1.56-1.56V45.48A.77.77,0,0,0,52.5,44.7Zm-.78,3.12h-3.9V46.26h3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50.16,19.72a3.13,3.13,0,1,0,3.12,3.12A3.12,3.12,0,0,0,50.16,19.72Zm0,4.69a1.57,1.57,0,1,1,1.56-1.57A1.56,1.56,0,0,1,50.16,24.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50.16,36.89A3.12,3.12,0,1,0,53.28,40,3.12,3.12,0,0,0,50.16,36.89Zm0,4.68A1.56,1.56,0,1,1,51.72,40,1.56,1.56,0,0,1,50.16,41.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M54.06,16.6H11.92a2.34,2.34,0,0,0-2.34,2.34v25a2.35,2.35,0,0,0,2.34,2.35H54.06a2.35,2.35,0,0,0,2.34-2.35v-25A2.34,2.34,0,0,0,54.06,16.6Zm.78,27.31a.79.79,0,0,1-.78.79H11.92a.79.79,0,0,1-.78-.79v-25a.78.78,0,0,1,.78-.78H54.06a.78.78,0,0,1,.78.78v25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M41.57,19.72h-25a3.91,3.91,0,0,0-3.9,3.91v15.6a3.91,3.91,0,0,0,3.9,3.9h25a3.91,3.91,0,0,0,3.91-3.9V23.63A3.91,3.91,0,0,0,41.57,19.72Zm2.34,19.51a2.34,2.34,0,0,1-2.34,2.34h-25a2.34,2.34,0,0,1-2.34-2.34V23.63a2.35,2.35,0,0,1,2.34-2.35h25a2.35,2.35,0,0,1,2.34,2.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M55.62,47.82H10.36a.78.78,0,1,0,0,1.56H55.62a.78.78,0,0,0,0-1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48.6,26.75a.78.78,0,0,0-.78.78v.78a.78.78,0,0,0,1.56,0v-.78A.78.78,0,0,0,48.6,26.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51.72,26.75a.78.78,0,0,0-.78.78v.78a.78.78,0,1,0,1.56,0v-.78A.78.78,0,0,0,51.72,26.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48.6,29.87a.78.78,0,0,0-.78.78v.78a.78.78,0,0,0,1.56,0v-.78A.78.78,0,0,0,48.6,29.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51.72,29.87a.78.78,0,0,0-.78.78v.78a.78.78,0,1,0,1.56,0v-.78A.78.78,0,0,0,51.72,29.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48.6,33a.78.78,0,0,0-.78.78v.78a.78.78,0,0,0,1.56,0v-.78A.78.78,0,0,0,48.6,33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51.72,33a.78.78,0,0,0-.78.78v.78a.78.78,0,0,0,1.56,0v-.78A.78.78,0,0,0,51.72,33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.06,23.07a.8.8,0,0,0-1.11,0L16.05,27a.77.77,0,0,0,0,1.1.77.77,0,0,0,1.1,0l3.91-3.9A.8.8,0,0,0,21.06,23.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25,23.07a.8.8,0,0,0-1.11,0l-2.34,2.34a.8.8,0,0,0,0,1.11.78.78,0,0,0,.55.23.82.82,0,0,0,.56-.23L25,24.18A.8.8,0,0,0,25,23.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.71,29.32a.77.77,0,0,0-1.1,0l-1.56,1.56a.77.77,0,0,0,0,1.1.77.77,0,0,0,1.1,0l1.56-1.56A.77.77,0,0,0,18.71,29.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.06,27A.78.78,0,0,0,20,27l-.78.78a.78.78,0,1,0,1.1,1.1l.79-.78A.78.78,0,0,0,21.06,27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M40.79,36.11H38.45V26.75h2.34a.78.78,0,1,0,0-1.56H37.67a.78.78,0,0,0-.78.78V36.89a.78.78,0,0,0,.78.78h3.12a.78.78,0,1,0,0-1.56Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicroonde);
export default __webpack_public_path__ + "static/media/microonde.47445aacff5e79f29219ceb822038f76.svg";
export { ForwardRef as ReactComponent };